import React from 'react';
import type { Level, TeaserPatient } from '../../data/teaser';
type PatientCardProps = {
  patient: TeaserPatient;
};
export function PatientCard({
  patient
}: PatientCardProps) {
  return <figure className="flex min-w-0 flex-col" data-id="element-139" data-mp="2dhmskg5mgiog">
      <div className="overflow-hidden rounded-2xl bg-wash" data-id="element-140" data-mp="2dier9zuimwiy">
        <img src={patient.image} alt={`${patient.label} portrait`} className="aspect-[5/6] w-full object-cover object-top grayscale-[35%]" data-id="element-141" data-mp="28jtqnzbcqatz" />
      </div>
      <figcaption className="mt-3" data-id="element-142" data-mp="3177ftb8t623j">
        <p className="text-[13px] font-semibold text-ink" data-id="element-143" data-mp="31893cf70gh25">{patient.label}</p>
        <dl className="mt-2 space-y-1.5" data-id="element-144" data-mp="2wfz3o7g3g2mo">
          <Row label="AMH" text={patient.amh.text} level={patient.amh.level} data-id="element-145" data-mp="2wewcdyeuzy68" />
          <Row label="Weight" text={patient.weight.text} level={patient.weight.level} data-id="element-146" data-mp="2rhedz1ygx1ch" />
        </dl>
      </figcaption>
    </figure>;
}
function Row({
  label,
  text,
  level
}: {
  label: string;
  text: string;
  level: Level;
}) {
  return <div className="flex items-center justify-between gap-2 border-t border-ink/10 pt-1.5" data-id="element-147" data-mp="3egyshe3n0ys5">
      <dt className="font-mono text-[10px] tracking-[0.12em] text-graphite" data-id="element-148" data-mp="3ejb8hlpu4z2k">{label.toUpperCase()}</dt>
      <dd className="flex items-center gap-2 text-[12px] font-medium text-ink" data-id="element-149" data-mp="3jhwbtu0dvyv8">
        {text}
        <span className="flex items-end gap-[2px]" aria-hidden="true" data-id="element-150" data-mp="35mu4r3jsw3gu">
          {[1, 2, 3].map(i => <span key={i} className={`w-[3px] rounded-full ${i <= level ? 'bg-ink' : 'bg-ink/15'}`} style={{
          height: 4 + i * 3
        }} data-id="element-151" data-mp="2vqh3nklxenc2" />)}
        </span>
      </dd>
    </div>;
}